// Delegado en document para seguir funcionando cuando el personalizador recarga la sección.
document.addEventListener('click', (e) => {
  const muestra = e.target.closest('.muestra');
  if (!muestra) return;
  const zona = muestra.closest('.tonos');
  const foco = zona.querySelector('.tonos__foco');
  const activa = muestra.getAttribute('aria-pressed') === 'true';
  zona.querySelectorAll('.muestra').forEach((m) => m.setAttribute('aria-pressed', 'false'));
  foco.classList.toggle('activo', !activa);
  if (!activa) {
    muestra.setAttribute('aria-pressed', 'true');
    foco.style.setProperty('--x', muestra.dataset.x + '%');
    foco.style.setProperty('--w', muestra.dataset.w + '%');
  }
});
